"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var create_error_1 = require("./create-error");

var validation_utils_1 = require("./validation.utils");

var defaults_1 = require("../defaults");

exports.validateCornerDesign = function (washBasinDimension, defaults) {
  var error;
  var typeOfInstallation = washBasinDimension.typeOfInstallation;
  var cornerDesign = washBasinDimension.cornerDesign;
  var cornerDesignPosition = washBasinDimension.cornerDesignPosition;

  switch (typeOfInstallation) {
    case 'left':
      defaults.cornerDesignPosition.values = ['right'];
      defaults.angleOfNiche.default = [90];

      if (cornerDesignPosition && cornerDesignPosition.indexOf('left') > -1) {
        error = create_error_1.createError({
          msg: "Value {{" + cornerDesignPosition + "}} isn't assignable to selected type of installation",
          code: 'NOT_ASSIGNABLE',
          inObject: 'washBasinDimension.cornerDesignPosition',
          statusCode: 400
        });
      }

      break;

    case 'right':
      defaults.cornerDesignPosition.values = ['left'];
      defaults.angleOfNiche.default = [90];

      if (cornerDesignPosition && cornerDesignPosition.indexOf('right') > -1) {
        error = create_error_1.createError({
          msg: "Value {{" + cornerDesignPosition + "}} isn't assignable to selected type of installation",
          code: 'NOT_ASSIGNABLE',
          inObject: 'washBasinDimension.cornerDesignPosition',
          statusCode: 400
        });
      }

      break;

    case 'with':
      defaults.cornerDesign.values = ['none'];
      defaults.cornerDesignPosition.values = null;
      defaults.angleOfNiche.default = [90, 90];

      if (cornerDesign !== 'none') {
        error = create_error_1.createError({
          msg: "{{" + cornerDesign + "}} isn't assignable to selected type of installation",
          code: 'NOT_ASSIGNABLE',
          inObject: 'washBasinDimension.cornerDesign',
          statusCode: 400
        });
      }

      if (cornerDesignPosition) {
        error = create_error_1.createError({
          msg: "{{" + cornerDesignPosition + "}} isn't assignable to selected type of installation",
          code: 'NOT_ASSIGNABLE',
          inObject: 'washBasinDimension.cornerDesignPosition',
          statusCode: 400
        });
      }

      break;

    default:
      defaults.cornerDesign.values = ['none', 'radius', 'bevel'];
      defaults.cornerDesignPosition.values = ['left', 'right'];
      defaults.angleOfNiche.default = null;
  }

  if (cornerDesign === 'none' && cornerDesignPosition) {
    defaults.cornerDesignPosition.values = null;
    error = create_error_1.createError({
      msg: "{{" + cornerDesignPosition + "}} isn't assignable if corner design is \"none\"",
      code: 'NOT_ASSIGNABLE',
      inObject: 'washBasinDimension.cornerDesignPosition',
      statusCode: 400
    });
  }

  defaults.typeOfInstallation.default = washBasinDimension.typeOfInstallation;
  defaults.cornerDesignPosition.default = washBasinDimension && washBasinDimension.cornerDesignPosition || null;
  return error ? error : defaults;
};

exports.assignDefaultWidth = function (plateWidth, defaults) {
  return {
    default: plateWidth.min,
    current: plateWidth.current,
    values: {
      min: plateWidth.min,
      max: defaults && defaults.plateWidth && defaults.plateWidth.values.max || defaults_1.configurationDefaults.washBasinDimension.plateWidth.values.max
    }
  };
};

exports.validatePlateWidth = function (washBasinDimension, plateWidth, defaults) {
  var error;
  var defaultPlateWidth = exports.assignDefaultWidth(plateWidth, defaults);
  var isInRange = validation_utils_1.inRange(washBasinDimension.plateWidth, {
    min: defaultPlateWidth.values.min,
    max: defaultPlateWidth.values.max
  });

  if (!isInRange) {
    error = create_error_1.createError({
      msg: "{{" + washBasinDimension.plateWidth + "}} isn't assignable, to big or to small",
      code: 'NOT_ASSIGNABLE',
      inObject: 'washBasinDimension.plateWidth',
      statusCode: 400
    });
  }

  defaults.plateWidth = defaultPlateWidth;
  return error ? error : defaults;
}; // export const setDefaultDepth = (depthDistanceTo: DepthDistanceToModel, trough: TroughModel): number[] => 
//   trough.variusmed || trough.preparedBackWallWith ? ([
//       depthDistanceTo.plateDepth.min,
//     ]) : ([
//       depthDistanceTo.plateDepth.min,
//       depthDistanceTo.plateDepthWithTapHole.min,
//       depthDistanceTo.plateDepth.max,
//     ]);


exports.assignDefaultDepth = function (plateDepth, trough) {
  return {
    default: trough.variusmed || trough.preparedBackWallWith ? plateDepth.min : 550,
    current: plateDepth.min,
    values: {
      min: plateDepth.min,
      max: plateDepth.max
    }
  };
};

exports.validatePlateDepth = function (washBasinDimension, defaults) {
  var error;

  if (washBasinDimension && washBasinDimension.plateDepth && washBasinDimension.plateDepth > 0) {
    var values = defaults.plateDepth.values;
    var plateDepth = {
      min: values.min,
      max: values.max
    };
    var isInRange = validation_utils_1.inRange(washBasinDimension.plateDepth, plateDepth);

    if (!isInRange) {
      error = create_error_1.createError({
        msg: "Value {{" + washBasinDimension.plateDepth + "}} isn't assignable",
        code: 'NOT_ASSIGNABLE',
        inObject: 'washBasinDimension.plateDepth',
        statusCode: 400
      });
    }
  }

  return error ? error : defaults;
};

exports.validateWashBasinDimension = {
  validateCornerDesign: exports.validateCornerDesign,
  validatePlateDepth: exports.validatePlateDepth
};
exports.default = exports.validateWashBasinDimension;